import React from "react";
import { motion } from "framer-motion";

// Hero image
import newsHero from "../assets/News-coverage-Cover-photo.jpg";

// Newspaper cutting images
import news1 from "../assets/news1.png";
import news2 from "../assets/news2.jpg";
import news3 from "../assets/news3.jpg";

const NewsCoverage = () => {
  const newsCoverage = [
    {
      id: 1,
      image: news1,
    },
    {
      id: 2,
      image: news2,
    },
    {
      id: 3,
      image: news3,
    },
  ];

  return (
    <div className="bg-black text-white min-h-screen">

      {/* ================= HERO ================= */}
      <section
        className="relative h-[60vh] flex items-center justify-center text-center bg-cover bg-center"
        style={{ backgroundImage: `url(${newsHero})` }}
      >
        {/* Background Overlay */}
        <div className="absolute inset-0 bg-black/65"></div>

        {/* Decorative circles */}
        <div className="absolute top-20 left-10 w-40 h-40 bg-lime-400/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-60 h-60 bg-lime-400/10 rounded-full blur-3xl"></div>

        <div className="relative z-10 max-w-4xl mx-auto px-6">

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-lime-400 uppercase tracking-[0.3em] text-sm font-semibold mb-5"
          >
            In The News
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-5xl md:text-7xl font-bold mb-6"
          >
            NEWS <span className="text-lime-400">COVERAGE</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="text-gray-300 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed"
          >
            A collection of newspaper articles and media coverage
            featuring the work of ACoT.
          </motion.p>

        </div>
      </section>


      {/* ================= NEWSPAPER CUTTINGS ================= */}
      <section className="py-20 bg-gray-950">

        <div className="w-11/12 md:w-4/5 mx-auto">

          {/* Heading */}
          <div className="text-center mb-14">

            <p className="text-lime-400 uppercase tracking-[0.25em] text-sm font-semibold mb-3">
              Media Recognition
            </p>

            <h2 className="text-3xl md:text-4xl font-bold text-lime-400">
              NEWS COVERAGE
            </h2>

            <div className="w-20 h-1 bg-lime-400 mx-auto mt-5"></div>

          </div>


          {/* Newspaper Images */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 items-start">

            {newsCoverage.map((item, index) => (

              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0.6,
                  delay: index * 0.1,
                }}
                whileHover={{ y: -6 }}
                className="
                  bg-white
                  rounded-xl
                  overflow-hidden
                  shadow-2xl
                  border
                  border-gray-700
                  hover:border-lime-400
                  transition-all
                  duration-300
                "
              >

                {/* Full Newspaper Image */}
                <img
                  src={item.image}
                  alt={`News coverage ${item.id}`}
                  className="
                    w-full
                    h-auto
                    object-contain
                    block
                  "
                />

              </motion.div>

            ))}

          </div>

        </div>

      </section>

    </div>
  );
};

export default NewsCoverage;